export default {
  // 布局
  layout: {
    themeStyle: '主题风格',
    styles: {
      grayBlue: '灰蓝色版',
      blue: '蓝色版',
      lightBlue: '湖蓝色版',
      green: '绿色版',
      red: '红色版',
      purple: '紫色版',
      gray: '灰色版'
    },
    welcome: '您好',
    station: 'jeecms主站',
    personal: '个人信息',
    password: '忘记密码',
    logout: '退出'
  },
  // 全局
  global: {
    day: '天',
    hour: '小时',
    minute: '分钟',
    confirm: '确定',
    cancel: '取消',
    yes: '是',
    no: '否',
    open: '打开',
    enabled: '启用',
    disabled: '禁用',
    delete: '删除',
    add: '添加',
    create: '新建',
    update: '更新',
    deploy: '发布',
    refresh: '刷新',
    close: '关闭',
    closeOther: '关闭其他',
    closeAll: '关闭所有',
    tip: '提示',
    handle: '操作',
    success: '成功',
    recover: '恢复',
    save: '保存',
    saveAndContinue: '保存并继续新建',
    autoSave: '自动保存',
    sort: '排序',
    index: '序号',
    prevPage: '上一页',
    nextPage: '下一页',
    screenFull: '全屏',
    cancelScreenFull: '退出全屏',
    download: '下载'
  },
  // 提示语
  message: {
    confirmDelete: '是否确定删除？',
    selectLeastOne: '至少选择一项进行操作'
  },
  // 验证信息
  rule: {
    required: '此项必填'
  }
}
